//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default{
    data(){
      return{
        titleTab:['贫困需求','项目计划','项目进度'],
        titleKey:0,
        contentDetails:[],
      }
    },
    methods:{
      goBack(){
        window.history.go(-1)
      },
      getTabCon(key){
        this.titleKey = key;
      },
      getcontentDetail(){
          var data = {
              id:this.$route.query.id
          }
          this.$https.post(this.BASE_URL+'/pps/organization/fpProjectSuccessDetail',data).then(
              res => {
                if(res.data.code == 'PPSI0000'){
                      this.contentDetails.push(res.data.data);
                }
              }
          ).catch(err => {
              console.log(err)
          })
      },
      formatTen(num) {
        return num > 9 ? (num + "") : ("0" + num);
      },
      formatDate(date) {
        if(date == null){
          return ''
        }else{
          var date = new Date(date)
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          var hour = date.getHours();
          var minute = date.getMinutes();
          var second = date.getSeconds();
          return year + "-" + this.formatTen(month) + "-" + this.formatTen(day)+ " " +this.formatTen(hour)+ ":" +this.formatTen(minute)+ ":" +this.formatTen(second);
        }
      }
    },
    mounted(){
      console.log(this.$route.query.id)
      this.getcontentDetail();
    }
  }



// WEBPACK FOOTER //
// ./src/crowd_fund/socialOrgan/successDetail.vue